import React from "react";
import {PageLayout} from "../../../components/layout/Page/PageLayout.jsx";

export const HomeLayout = ({children, showNav = true, ...otherProps}) => {

    return (
        <PageLayout >
            {children}
        </PageLayout>
    );
}